import React from 'react';
import { Link } from 'react-router-dom';
import { formatShortDate } from '../../../utils/articleUtils';

const BlogLatestPostsSection = ({ posts, postsStatus }) => {
  return (
    <section aria-labelledby="latest-posts-title" className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          id="latest-posts-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Últimos artigos
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Conteúdo técnico e prático — notas, guias e análises que apoio com referências e exemplos.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {postsStatus === 'loading' && (
          <div className="col-span-full text-center text-gray-600">Carregando artigos...</div>
        )}
        {postsStatus === 'error' && (
          <div className="col-span-full text-center text-red-600">
            Não foi possível carregar os artigos agora. Tente novamente mais tarde.
          </div>
        )}
        {postsStatus === 'success' && posts.length === 0 && (
          <div className="col-span-full text-center text-gray-600">
            Nenhum artigo disponível no momento.
          </div>
        )}
        {postsStatus === 'success' &&
          posts.map((post) => {
            const dateLabel = formatShortDate(post.publishedAt) || 'Sem data';

            return (
              <Link
                key={post.id}
                to={`/blog/artigos/${post.slug}`}
                className="group block"
                aria-label={`Ler artigo ${post.title}`}
              >
                <article className="bg-white rounded-lg border border-gray-200 shadow-lg site-card overflow-hidden flex flex-col h-full transition-shadow duration-300 group-hover:shadow-xl">
                  <div className="p-6 flex-grow">
                    <div className="flex items-center justify-between mb-3">
                      <span className="inline-block bg-blue-50 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">
                        {post.category}
                      </span>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">{post.title}</h3>
                    <p className="mt-4 text-gray-600">{post.excerpt}</p>
                  </div>
                  <div className="bg-gray-50 p-4 border-t border-gray-200 site-card-strip flex items-center justify-between text-sm text-gray-500">
                    <span className="text-gray-600">{dateLabel}</span>
                    <span className="text-gray-600">{post.readTime} min de leitura</span>
                  </div>
                </article>
              </Link>
            );
          })}
      </div>
      <div className="text-center mt-12">
        <Link to="/blog/artigos" className="text-lg font-semibold text-blue-600 hover:underline">
          Ver todos os artigos
        </Link>
      </div>
    </section>
  );
};

export default BlogLatestPostsSection;
